import React, { SetStateAction, useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { callNotify } from '../../../../..';
import { SpotService } from "../../../../../util/services/spot";
import { selectTenantId } from '../../../../../util/store/selectors';
import { getStore } from "../../../../../util/store/store";
import { CONTRACT_TYPE } from "../../../../../util/varibles/constants";
import { showErrorResponse } from "../../../../../util/varibles/global";
import { IVessel } from "../../../../../util/varibles/interface";
import { notify, NotifyCode } from "../../../../../util/varibles/message";
import { selectPlan } from '../../../constants';
import { planOpActions } from "../../../reducer";
import { convertPxToTimeByStep } from "../../../util";
import { planValidation, VALIDATION } from "../../../util/validation";
import styles from "./style.module.scss";

interface IProps {
    data: any
    name: string
    vessel: IVessel

    setTime(time: SetStateAction<{ start_time: number, finish_time: number }>): void

    setLoading(loading: boolean): void
}

let targetY = 0;

const DragLine: React.FC<IProps> = (props) => {
    const {
        data,
        vessel,
        name,
        ...args
    } = props;
    const userTenantId = useSelector(selectTenantId);
    const funcRef = useRef({ ...args });
    const dispatch = useDispatch();

    const { start_time: start, finish_time: finish } = data;
    const dragStart = (e: any) => {
        e.stopPropagation();
        const { pageY } = e;
        if (props.name === 'start')
            document.addEventListener('mousemove', dragMoveStart);
        else
            document.addEventListener('mousemove', dragMoveFinish);

        document.addEventListener('mouseup', dragEnd);
        targetY = pageY;
    }

    const dragMoveStart = useCallback((e: any) => {
        const { pageY } = e;
        const duration = convertPxToTimeByStep(pageY - targetY);
        const { setTime } = funcRef.current;
        setTime(prev => ({ ...prev, start_time: start + duration }))
    }, [start])

    const dragMoveFinish = useCallback((e: any) => {
        const { pageY } = e;
        const duration = convertPxToTimeByStep(pageY - targetY);
        const { setTime } = funcRef.current;
        setTime(prev => ({ ...prev, finish_time: finish + duration }))
    }, [finish])

    const dragEnd = useCallback((e: any) => {
        document.removeEventListener('mousemove', dragMoveStart);
        document.removeEventListener('mousemove', dragMoveFinish);
        document.removeEventListener('mouseup', dragEnd);
        const { pageY } = e;
        const duration = convertPxToTimeByStep(pageY - targetY);
        let { id, start_time, finish_time } = data;

        if (name === 'start') {
            start_time = data.start_time + duration;
        } else {
            finish_time = data.finish_time + duration;
        }
        const state = getStore();
        const level = selectPlan.level(state);
        const operations = selectPlan.ops(state);
        let { message } = planValidation[VALIDATION.AVAILABLE_TIME]({ ...data, start_time, finish_time }, { operations, level })

        if (message.length === 0) {
            const { contracts, available_times } = vessel;
            let isError = contracts.some(item => item.type === CONTRACT_TYPE.FIXED
                && item.tenant_id !== userTenantId
                && start_time <= item.finish_time
                && item.start_time <= finish_time)
            if (isError) {
                message = notify[NotifyCode.E6]();
            } else {
                isError = available_times.some((item: any) => item.id !== id
                    && start_time <= item.finish_time
                    && item.start_time <= finish_time)

                if (isError) {
                    message = notify[NotifyCode.E6]()
                }
            }
        }
        const { setTime, setLoading } = funcRef.current
        if (message.length > 0) {
            callNotify?.error({ title: 'Error', description: message });
            const { start_time, finish_time } = data;
            setTime({ start_time, finish_time })
        } else {
            setLoading(true);
            SpotService.updateAvailableTime({
                ...data,
                start_time: start_time.valueOf(),
                finish_time: finish_time.valueOf()
            })
                .then(rs => {
                    setLoading(false);
                    dispatch(planOpActions.updateAvailableTime(rs))
                    notify.success(NotifyCode.S2)('Available time');
                })
                .catch(error => {
                    setLoading(false);
                    showErrorResponse(`Update failed`, error);
                })
        }
    }, [dragMoveStart, dragMoveFinish, data, name, vessel, userTenantId, dispatch])

    useEffect(() => {
        return () => {
            document.removeEventListener('mousemove', dragMoveStart);
            document.removeEventListener('mousemove', dragMoveFinish);
            document.removeEventListener('mouseup', dragEnd);
        };
    }, [dragMoveStart, dragMoveFinish, dragEnd]);

    return <div {...{
        className: styles.line,
        'data-line-type': props.name,
        onMouseDown: (e) => dragStart(e)
    }} />
};

export default DragLine

